/**
 * Returns the current fiscal year.
 * If current month is July (6) or later, returns next year.
 * Otherwise returns current year.
 */
export const getCurrentYear = (): number => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  return currentDate.getMonth() >= 6 ? currentYear + 1 : currentYear;
};
